import { render, staticRenderFns } from "./FormControlEmailMessageEvent.vue?vue&type=template&id=066a3450&scoped=true"
import script from "./FormControlEmailMessageEvent.vue?vue&type=script&setup=true&lang=js"
export * from "./FormControlEmailMessageEvent.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FormControlEmailMessageEvent.vue?vue&type=style&index=0&id=066a3450&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066a3450",
  null
  
)

export default component.exports